import { useEffect, useState } from 'react'
import { Bars4Icon, XMarkIcon } from '@heroicons/react/24/solid'
import ButtonEl from '../helpers/ctas/Button'
import themeConfig from '../../../theme.config'
import MainNav from './MainNav'

function MobileNav(props) {
  const [menuActive, setMenuActive] = useState(false)

  const content = (
    <>
      <div
        className={`relative group/menu h-6 w-6 ${menuActive && (props.searchActive === false || props.searchActive === undefined) ? 'active' : 'inactive'}`}
      >
        <div className="absolute top-0 left-0">
          <Bars4Icon
            className="h-6 w-6 text-base-text group-[.active]/menu:rotate-90 group-[.active]/menu:opacity-0 group-[.inactive]/menu:rotate-0 group-[.inactive]/menu:opacity-100 transition-all duration-1000"
            role="none"
          />
        </div>
        <div className="absolute top-0 left-0">
          <XMarkIcon
            className="h-6 w-6 text-base-text group-[.active]/menu:rotate-0 group-[.active]/menu:opacity-100 group-[.inactive]/menu:rotate-90 group-[.inactive]/menu:opacity-0 transition-all duration-1000"
            role="none"
          />
        </div>
        <span className="sr-only">Toggle mobile menu</span>
      </div>
    </>
  )

  useEffect(() => {
    setMenuActive((prevState) => (props.searchActive === true || props.ctasActive === true ? false : prevState))
  }, [props.searchActive, props.ctasActive, props.menuActive])

  useEffect(() => {
    if (props.type === 'mobile') {
      document.addEventListener('click', (evt) => {
        if (
          !evt.target.closest('[data-type="mobileNavTrigger"]') &&
          !evt.target.closest('[data-type="mobile-navigation"]')
        ) {
          setMenuActive(false)
        }
      })
    }
  }, [])

  const handleClick = () => {
    // let isActive = false
    setMenuActive((prevState) => {
      const isActive = !prevState
      props.setMenuActive(isActive)
      props.setSearchActive((prevState) => {
        let newState = prevState
        if (isActive === true) {
          // is search has become active turn the menu off
          newState = false
        }
        // otherwise do nothing.
        props.setCtasActive(newState)
        return newState
      })
      return isActive
    })
  }

  return (
    <>
      <div
        data-type="mobileNavTrigger"
        className={`peer/menutrigger ${menuActive && (props.searchActive === false || props.searchActive === undefined) ? 'active' : 'inactive'} xl:hidden ml-3`}
      >
        <ButtonEl theme={'tertiary'} className="!px-0 !shadow-none h-full items-center" onClick={handleClick}>
          {content}
        </ButtonEl>
      </div>
      <div
        data-type="mobile-navigation-wrapper"
        className={`group/wrapper shadow-md ${menuActive ? 'active' : 'inactive'}  bg-${themeConfig.settings.nav.mobile.base} text-${themeConfig.settings.nav.mobile.base}-text`}
      >
        <div>
          <MainNav {...props} nav={props.nav} type={props.type} stub="mob" />
        </div>
      </div>
    </>
  )
}

export default MobileNav
